module.exports = __webpack_public_path__ + "static/media/login-img.9bee5f3c.svg";